import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import PrimaryContact from './PrimaryContact';
import styles from './styles';

function PrimaryContactLessor(props) {
  const { classes, handleChange, form, ownerships } = props;

  return (
    <div className={classes.paperCardFrame} style={{ order: 6 }}>
      <PrimaryContact handleChange={handleChange} ownerships={ownerships} form={form} topAvatar={false} />
    </div>
  );
}

PrimaryContactLessor.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  ownerships: PropTypes.array.isRequired,
};

export default withStyles(styles)(PrimaryContactLessor);
